import { Marker, MarkerProps, Tooltip, } from 'react-leaflet'
import { SisetuMapPoint } from '../types'
import { clusterPin } from '../util'
import { SisetuPopup } from "./sisetuPopup"
import { SisetuMarker } from './sisetuMarker'

type LocationMarkerProps = {
	point: SisetuMapPoint
	onOpen: (sisetuCode: string) => void
	onClose: () => void
} & Omit<MarkerProps, 'position' | 'icon'>
export const LocationMarker = ({
	point,
	onOpen,
	onClose,
	...others
}: LocationMarkerProps) => {
  if (point.sisetuList.length <= 0) return <></>
  if (point.sisetuList.length === 1) {
    return (
      <SisetuMarker
        sisetu={point.sisetuList[0]}
        onOpen={onOpen}
        onClose={onClose}
        {...others}
      />
    )
  }
  return (
    <Marker
      {...others}
      position={point.position}
      zIndexOffset={2}
      icon={clusterPin(point.sisetuList.length)}
      autoPan
    >
      <Tooltip
        direction="top"
        className="tooltip"
        offset={[0, -20]}
        opacity={1}
      >
        {point.sisetuList.length}施設
      </Tooltip>

      <SisetuPopup
        sisetuList={point.sisetuList}
        onOpen={onOpen}
        onClose={onClose}
      />
    </Marker>
  )
}
